import React from 'react'
import { translate } from 'react-i18next'
import { func } from 'prop-types'
import { Link } from 'react-router-dom'
import { stores, view } from '../../stores'
import { Loader } from '../ui/states/Loader'
import { PagesPaths } from '../../constants/Pages'
import { ProfilePicture } from '../ui/ProfilePicture'
import './AccountDetails.css'

const AccountDetailsComponent = ({ t }) => {
  const account = stores.account.connected
  if (!account) {
    return (<Loader size='small' />)
  }
  return (
    <div className='account-card'>
      <div className='account-card__identity'>
        <ProfilePicture rounded className='account-card__avatar' picture={account.profilePicture} />
        <p className='account-card__name'>{account.firstName} {account.lastName.toUpperCase()}</p>
      </div>
      <ul className='account-card__rows'>
        <li className='account-card__row'>
          <span className='account-card__label'>{t('common:account:label_address')}</span>
          <span className='account-card__value'>{account.address.address}, {account.address.zipCode} {account.address.city}</span>
        </li>
        <li className='account-card__row'>
          <span className='account-card__label'>{t('common:account:label_phone')}</span>
          <span className='account-card__value'>{account.phone && account.phone.value ? account.phone.value : account.phone}</span>
        </li>
        <li className='account-card__row'>
          <span className='account-card__label'>{t('common:account:label_email')}</span>
          <span className='account-card__value'>{account.email}</span>
        </li>
        {
          account.gardenSurface > 0
          ? <li className='account-card__row'>
            <span className='account-card__label'>{t('common:account:surface_garden')}</span>
            <span className='account-card__value'>{account.gardenSurface}</span>
          </li>
          : ''
        }
      </ul>
      <div className='account-card__actions'>
        <Link className='account-card__btn' to={PagesPaths.ACCOUNT_EDIT.path}>{t('common:buttons:account_modify')}</Link>
        <Link className='account-card__btn account-card__btn--ghost' to={PagesPaths.AVANCE_IMMEDIATE.path}>{t('common:buttons:account_avance_immediate')}</Link>
      </div>
    </div>
  )
}

AccountDetailsComponent.propTypes = {
  t: func
}

export const AccountDetails = translate()(view(AccountDetailsComponent))



// WEBPACK FOOTER //
// ./src/components/customer/AccountDetails.js